import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import Maincomponent from "./components/maincomponent";
import "./css/overrides.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Maincomponent />
  </React.StrictMode>
);

reportWebVitals();
